"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Keys_1 = __importDefault(require("./Keys"));
var Combos_less_1 = __importDefault(require("./Combos.less"));
var Combos = function (_a) {
    var combos = _a.combos;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: Combos_less_1.default['combos'] }, combos.map(function (keys, index) { return (react_1.default.createElement("div", { className: Combos_less_1.default['combo'], key: index },
        react_1.default.createElement(Keys_1.default, { keys: keys }),
        index < (combos.length - 1) && (react_1.default.createElement("div", { className: Combos_less_1.default['separator'] }, t('SETTINGS_SHORTCUT_OR'))))); })));
};
exports.default = Combos;
